import fazendaImg from '../assets/fazenda-leiteira.webp';
import obrasImg from '../assets/controle-obras.png';
import locacaoImg from '../assets/locacao-equipamentos.png';

export const products = [
  {
    slug: 'fazenda-leiteira',
    title: 'Fazenda Leiteira',
    tag: 'Gestão Rural',
    color: '#22c55e',
    icon: 'fas fa-cow',
    image: fazendaImg,
    gallery: [fazendaImg, fazendaImg, fazendaImg],
    short:
      'Sistema completo para controle da produção de leite, rebanho, custos, estoque, reprodução, saúde animal e lucratividade.',
    details: [
      ['Categoria', 'Gestão Rural'],
      ['Plataforma', 'Web e Mobile'],
      ['Ideal para', 'Produtores de leite, fazendas e propriedades rurais'],
      ['Suporte', 'Online e WhatsApp'],
    ],
    benefits: ['Mais controle', 'Mais produtividade', 'Mais lucro'],
    features: [
      ['fas fa-droplet', 'Produção de Leite', 'Registre e acompanhe a produção diária e histórica do seu rebanho.'],
      ['fas fa-cow', 'Rebanho', 'Controle completo dos animais, lotes, genealogia e indicadores.'],
      ['fas fa-seedling', 'Reprodução', 'Acompanhe cio, inseminações, prenhez e partos.'],
      ['fas fa-shield-heart', 'Saúde Animal', 'Vacinações, tratamentos, doenças e histórico de atendimentos.'],
      ['fas fa-coins', 'Custos e Despesas', 'Veja custos por categoria e o custo por litro de leite.'],
      ['fas fa-warehouse', 'Estoque e Insumos', 'Controle entradas, saídas e consumo de ração e medicamentos.'],
      ['fas fa-chart-line', 'Indicadores', 'Relatórios e gráficos para acompanhar produtividade e lucratividade.'],
      ['fas fa-bell', 'Alertas Inteligentes', 'Receba avisos importantes sobre animais e atividades.'],
      ['fas fa-users', 'Acesso Multiusuário', 'Permita acesso da equipe com segurança.'],
    ],
  },
  {
    slug: 'controle-de-obras',
    title: 'Controle de Obras',
    tag: 'Construção Civil',
    color: '#f59e0b',
    icon: 'fas fa-helmet-safety',
    image: obrasImg,
    gallery: [obrasImg, obrasImg, obrasImg],
    short:
      'Controle obras, etapas, equipes, materiais, cronogramas, registros fotográficos, custos e relatórios em uma única plataforma.',
    details: [
      ['Categoria', 'Construção Civil'],
      ['Plataforma', 'Web e Mobile'],
      ['Ideal para', 'Construtoras, engenheiros, gestores e equipes de obras'],
      ['Suporte', 'Online e WhatsApp'],
    ],
    benefits: ['Mais organização', 'Menos atrasos', 'Mais controle'],
    features: [
      ['fas fa-building', 'Cadastro de Obras', 'Organize obras, responsáveis, status, prazos e dados principais.'],
      ['fas fa-list-check', 'Etapas e Cronograma', 'Acompanhe fases, datas previstas, progresso e atrasos.'],
      ['fas fa-coins', 'Custos da Obra', 'Controle materiais, mão de obra, serviços e despesas extras.'],
      ['fas fa-users-gear', 'Equipes', 'Gerencie equipes, fornecedores e responsáveis por etapa.'],
      ['fas fa-camera', 'Fotos e Evidências', 'Registre a evolução da obra com fotos e observações.'],
      ['fas fa-chart-line', 'Relatórios', 'Veja evolução, custos, produtividade e indicadores.'],
    ],
  },
  {
    slug: 'locafacil-obras',
    title: 'LocaFácil Obras',
    tag: 'Locação de Equipamentos',
    color: '#06b6d4',
    icon: 'fas fa-truck-ramp-box',
    image: locacaoImg,
    gallery: [locacaoImg, locacaoImg, locacaoImg],
    short:
      'Sistema para gerenciar equipamentos, contratos, reservas, manutenção, devoluções, clientes e faturamento.',
    details: [
      ['Categoria', 'Locação de Equipamentos'],
      ['Plataforma', 'Web e Mobile'],
      ['Ideal para', 'Locadoras de equipamentos, máquinas e ferramentas'],
      ['Suporte', 'Online e WhatsApp'],
    ],
    benefits: ['Mais disponibilidade', 'Menos perdas', 'Mais faturamento'],
    features: [
      ['fas fa-truck-ramp-box', 'Equipamentos', 'Controle status, disponibilidade, histórico e localização.'],
      ['fas fa-calendar-check', 'Agenda de Locações', 'Visualize reservas, retiradas e devoluções.'],
      ['fas fa-file-contract', 'Contratos', 'Organize clientes, obras, prazos, valores e condições.'],
      ['fas fa-screwdriver-wrench', 'Manutenção', 'Acompanhe revisões, avarias, paradas e custos.'],
      ['fas fa-coins', 'Financeiro', 'Controle cobranças, faturamento e receitas por equipamento.'],
      ['fas fa-chart-line', 'Indicadores', 'Veja ocupação, rentabilidade e equipamentos parados.'],
    ],
  },
  {
    slug: 'atende24h',
    title: 'Atende24h IA',
    tag: 'Atendimento Inteligente',
    color: '#6366f1',
    icon: 'fas fa-robot',
    image: null,
    gallery: [],
    short:
      'Atendimento inteligente com WhatsApp, IA, automações, multiatendimento, histórico de conversas e relatórios.',
    details: [
      ['Categoria', 'Atendimento com IA'],
      ['Plataforma', 'WhatsApp, Web e Integrações'],
      ['Ideal para', 'Empresas que querem responder rápido e atender melhor'],
      ['Suporte', 'Online e WhatsApp'],
    ],
    benefits: ['Atendimento 24h', 'Mais agilidade', 'Menos perda de clientes'],
    features: [
      ['fab fa-whatsapp', 'WhatsApp Inteligente', 'Respostas automáticas e transferência para atendentes.'],
      ['fas fa-robot', 'IA Treinada', 'Responde com base nos documentos e informações da empresa.'],
      ['fas fa-headset', 'Multiatendimento', 'Vários atendentes trabalhando com histórico centralizado.'],
      ['fas fa-diagram-project', 'Automações', 'Fluxos para vendas, suporte, cobrança e pós-venda.'],
      ['fas fa-chart-column', 'Relatórios', 'Tempo de resposta, produtividade e volume de atendimento.'],
      ['fas fa-building', 'Setores', 'Comercial, financeiro, suporte e departamentos separados.'],
    ],
  },
];